export const RESIGNATION_REQUESTS_PATH = "/requests/resignation";
